<script setup lang="ts">
import { ref } from "vue"
import StarPicker from "@/components/reusable/starPicker.vue"
import type { AcContactData } from "@/types/crm"
const props = defineProps(["email"])
const emit = defineEmits(["potential-added", "cancel"])


const potentialName = ref("")
const potentialType = ref<"company" | "individual" | null>(null)
const potentialRating = ref(0)

const emitPotentialAdded = () => {
    const contactInformation: AcContactData = {
        title: "Genel",
        emailAddress: props.email.email,
        phoneNumber: props.email.phone,
        address:"",
        website: props.email.companyUrl,
    }

    
    emit("potential-added", {
        title: potentialName.value,
        type: potentialType.value,
        potentialRating: potentialRating.value,
        contact: [contactInformation],
    })
}

const cancel = () => {
    emit("cancel")
}

</script>

<template>
    <form @submit.prevent="emitPotentialAdded" class="ac-main-form !border-none !shadow-none">
        <div class="border p-4 text-2xl border-gray-200 rounded-lg my-4">
            Seçtiğiniz iletişim bilgileri, potansiyelin iletişim bilgileri olarak otomatik şekilde eklenecektir. Diğer bilgileri daha sonra potansiyel sayfasından düzenleyebilirsiniz.
        </div>
        <div class="flex justify-between items-center">
            <div class="ac-form-control w-3/4">
            <label for="potentialName">Potansiyel Adı</label>
            <input type="text" id="potentialName" v-model="potentialName" required>
        </div>
        <div class="ac-form-control mt-8">
            <star-picker @update:picked-quantity="potentialRating = $event" v-model="potentialRating" :maxQuantity="5" :pickedQuantity="potentialRating" />
        </div>
        </div>
        <div class="ac-form-control">
            <label for="potentialType">Potansiyel Tipi</label>
            <select class="py-3" id="potentialType" v-model="potentialType" required>
                <option value="company">Şirket</option>
                <option value="individual">Bireysel</option>
            </select>
        </div>
        <div class="ac-button-row justify-center gap-4 flex">
            <button type="submit" class="ac-primary-button">Potansiyel Oluştur</button>
            <button type="button" @click="cancel()" class="ac-secondary-button">İptal</button>
        </div>
    </form>
</template>